import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as DocumentFieldsActions from './documentfields.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { DocumentFieldService } from '../documentfield.service';

@Injectable()
export class DocumentFieldsEffects {

    constructor(
        private actions$: Actions,
        private documentFieldService: DocumentFieldService
    ) { }
    loadDocumentFields$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DocumentFieldsActions.loadDocumentFields),
            mergeMap(({ page }) =>
                this.documentFieldService.getAllDocumentfields(
                    page,
                    '',
                    `section=document_field&all=true`
                ).pipe(
                    map((response) =>
                        DocumentFieldsActions.loadDocumentFieldsSuccess({ documentFields: response })
                    ),
                    catchError((error) =>
                        of(DocumentFieldsActions.loadDocumentFieldsFailure({ error: error.message }))
                    )
                )
            )
        )
    );

    loadContactFields$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DocumentFieldsActions.loadContactFields),
            mergeMap(() =>
                this.documentFieldService.getAllDocumentfields(
                    '',
                    '',
                    'all=true&sections=[person_field,org_field]&source=SimpleSign'
                ).pipe(
                    map((response) =>
                        DocumentFieldsActions.loadContactFieldsSuccess({ documentFields: response })
                    ),
                    catchError((error) =>
                        of(DocumentFieldsActions.loadContactFieldsFailure({ error: error.message }))
                    )
                )
            )
        )
    );

    markStaleAfterFieldChange$ = createEffect(() =>
        this.actions$.pipe(
        ofType(DocumentFieldsActions.updateContactFields),
        map(() => DocumentFieldsActions.markContactFieldsStale())
        )
    );

    reloadContactFieldsWhenStale$ = createEffect(() =>
        this.actions$.pipe(
        ofType(DocumentFieldsActions.markContactFieldsStale),
        map(() => DocumentFieldsActions.loadContactFields())
        )
    );
}
